import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ReportsRequestPage.CustomMonthlyScheduleOption', {
    everyText: 'Every',
    onDay: 'on',
    timeLabel: 'at',

    day25th: '25th day of month',
    mondayOf4thWeek: 'Monday of 4th week',
    fridayOf4thWeek: 'Friday of 4th week',
    customDay: 'Custom day',
});
